/* KLS Drops — Countdown Timer & Form Handlers */

class KLSDropCountdown {
  constructor(el) {
    this.el = el;
    this.target = new Date(el.dataset.countdown).getTime();
    this.render();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  tick() {
    const diff = this.target - Date.now();
    if (diff <= 0) {
      clearInterval(this.interval);
      this.onEnd();
      return;
    }
    this.render(diff);
  }

  render(diff) {
    if (diff === undefined) diff = Math.max(0, this.target - Date.now());
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    this.el.innerHTML = `
      <div class="countdown-units">
        <div class="countdown-unit">
          <span class="countdown-num">${d}</span>
          <span class="countdown-label">Days</span>
        </div>
        <div class="countdown-unit">
          <span class="countdown-num">${String(h).padStart(2,'0')}</span>
          <span class="countdown-label">Hrs</span>
        </div>
        <div class="countdown-unit">
          <span class="countdown-num">${String(m).padStart(2,'0')}</span>
          <span class="countdown-label">Min</span>
        </div>
        <div class="countdown-unit">
          <span class="countdown-num">${String(s).padStart(2,'0')}</span>
          <span class="countdown-label">Sec</span>
        </div>
      </div>`;
  }

  onEnd() {
    this.el.innerHTML = '<p style="font-family:var(--font-heading);font-style:italic;color:#aaa;margin:0;">This drop has closed.</p>';
    document.querySelectorAll('[data-drop-active]').forEach(el => el.style.display = 'none');
    document.querySelectorAll('[data-drop-ended]').forEach(el => el.style.display = 'block');
  }
}

document.addEventListener('DOMContentLoaded', () => {

  // Init all countdown timers
  document.querySelectorAll('[data-countdown]').forEach(el => {
    if (el.dataset.countdown) new KLSDropCountdown(el);
  });

  // Email signup form handler — works for all three forms
  ['DropEarlyAccessForm', 'LinksNewsletterForm', 'NotifyMeForm'].forEach(id => {
    const form = document.getElementById(id);
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      this.innerHTML = '<p style="font-family:var(--font-heading);font-style:italic;font-size:1rem;color:var(--color-gold);text-align:center;margin:0;padding:0.5rem 0;">You\'re on the list.</p>';
    });
  });

});